import { ExternalAuthService } from './ExternalAuthService';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { TeslaSpinnerComponent } from 'node_modules/@tesla/angular2-tesla-common/spinner/spinner.component';
import { AuthService, AuthData, TokenResult, AuthConfig, AuthStorage, AuthConfigProvider  } from '@tesla/ng-auth';
import { StorageSettings } from './utils/storage.settings';
import { AppGlobalDataService } from './services/appglobaldata.service';
import { LocalstorageService } from './services/localstorage.service';
import { UISupplierContext } from './models/internal/uisuppliercontext';
import { SuppliercontextComponent } from './commonUI/suppliercontext/suppliercontext.component';
import { Constants } from './core/constants';
import {
    Router, NavigationStart, NavigationEnd,
    NavigationCancel, NavigationError, Event
  } from '@angular/router';
import { SpinnerService } from './services/spinner.service';
import { NGXLogger } from 'ngx-logger';
import UIHelper from './core/utility/ui-helper';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    public userName: string;
    public adUserName: string;
    public releaseVersion: string;
    UserDisplayName: string;
    UISupplierContexts: UISupplierContext[];
    @ViewChild(SuppliercontextComponent)
    suppliercontextComponent: SuppliercontextComponent;
    IsEmployee: string = '0';
    IsAdmin: string = '0';
    IsSupplier = false;
    locStorage = Constants.localStorageKeys;
    showLoadingIndicator = true;
    public _authData: AuthData;
    constructor(
        public storage: StorageSettings,
        public appSettings: AppSettings,
        private authService: AuthService,
        private authData: AuthData,
        private localstorageService: LocalstorageService,
        private appGlobalDataService: AppGlobalDataService,
        private spinnerService: SpinnerService,
        private _router: Router,
        protected authConfigProvider: AuthConfigProvider,
        protected logger: NGXLogger,
       private authExternalService: ExternalAuthService) {
        this._authData = authData;
        this._router.events.subscribe((routerEvent: Event) => {
            if (routerEvent instanceof NavigationEnd ||
                routerEvent instanceof NavigationError ||
                routerEvent instanceof NavigationCancel) {
                    if (this.suppliercontextComponent) {
                        logger.debug('Router event fired. Restoring SupplierContext. Event:' + routerEvent);
                        this.suppliercontextComponent.setSupplierContext();
                    }
              }
            });
            UIHelper.updateLoggerConfig(appSettings, logger);
    }

    ngOnInit() {
        // this.authService.execute();
        this.authService.execute().onSuccess((token: TokenResult, authConfig: AuthConfig, authData: AuthData, authStorage: AuthStorage,
            resolve: (value?: boolean | PromiseLike<boolean>) => void) => {
                this.authExternalService.onSuccess(authConfig, authData, this._router, authStorage, this.storage, this.appSettings);
                resolve(true);
        })
        .onError((err, errDesc) => {
            this.logger.debug(`Error: ${err}`);
            this.logger.debug(`Desc: ${errDesc}`);
        });

        const locStorage = this.locStorage;
        this.reloadStorage();

            this.appGlobalDataService.currentSupplierCode.subscribe(data => {
                if (data) {
                    this._router.navigate(['/']);
                }
            });
            this.appGlobalDataService.UserDisplayName.subscribe(data => {
                if (data) {
                this.UserDisplayName = data;
                this.localstorageService.store(locStorage.UserDisplayName, this.UserDisplayName);
                }
            });

            this.appGlobalDataService.IsSupplier.subscribe(data => {
                if (data != null) {
                    this.logger.debug('IsSupplier=', data);
                    this.IsSupplier = data;
                    this.localstorageService.store(locStorage.IsSupplier, this.IsSupplier);
                }
            });

            this.appGlobalDataService.IsEmployee.subscribe(data => {
                if (data) {
                this.IsEmployee = data;
                this.localstorageService.store(locStorage.IsEmployee, this.IsEmployee);
                }
            });
            this.appGlobalDataService.IsAdmin.subscribe(data => {
                if (data) {
                this.IsAdmin = data;
                this.localstorageService.store(locStorage.IsAdmin, this.IsAdmin);
                }
            });
            this.appGlobalDataService.UISupplierContexts.subscribe(data => {
                if (data) {
                this.UISupplierContexts = data;
                this.localstorageService.store(locStorage.UISupplierContexts, this.UISupplierContexts);
                }
            });

            // on reload, try to restore
            if (!this.UserDisplayName) {
                this.UserDisplayName = this.localstorageService.retrieve(locStorage.UserDisplayName);
            }
    }

    public Logout(event: any) {
        // TODO: review why dataservice emitlogout needed
        // this.dataService.emitLogOut(true);
        this.authService.logout();
    }

    public reloadStorage() {
        const locStorage = this.locStorage;
        this.IsSupplier = this.localstorageService.retrieve(locStorage.IsSupplier);
        this.IsAdmin = this.localstorageService.retrieve(locStorage.IsAdmin);
        this.IsEmployee = this.localstorageService.retrieve(locStorage.IsEmployee);

        this.appGlobalDataService.RefreshIsSupplier(this.IsSupplier);
        this.appGlobalDataService.RefreshIsEmployee(this.IsEmployee);
        this.appGlobalDataService.RefreshIsAdmin(this.IsAdmin);
    }
}
